"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthGate = void 0;
const react_1 = __importStar(require("react"));
const useSession_1 = require("../../hooks/useSession");
const DefaultLoadingFallback_1 = require("./DefaultLoadingFallback");
const constants_1 = require("../../../constants");
const LoginRedirect = () => {
    (0, react_1.useEffect)(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const params = new URLSearchParams();
        params.set('destination', `${window.location.pathname}${window.location.search}`);
        const redirectTo = `${constants_1.IDENTITY_BASE_PATH}/login?${params.toString()}`;
        window.location.assign(redirectTo);
    }, []);
    return null;
};
const AuthGate = ({ children, loadingFallback = react_1.default.createElement(DefaultLoadingFallback_1.DefaultLoadingFallback, null), unauthenticatedFallback = react_1.default.createElement(LoginRedirect, null), isPublic = false, }) => {
    const session = (0, useSession_1.useSession)();
    if (isPublic) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    if (session.status === 'loading') {
        return react_1.default.createElement(react_1.default.Fragment, null, loadingFallback);
    }
    if (session.status === 'unauthenticated') {
        return react_1.default.createElement(react_1.default.Fragment, null, unauthenticatedFallback);
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.AuthGate = AuthGate;
